import React from "react";
import "./stickyNavbar.css";

const StickyNavbar = props => {
  return <div className="sticky-navbar">{props.children}</div>;
};

export default StickyNavbar;
